module.exports = __webpack_public_path__ + "img/Iconset_DGBRT--23.9b029823.png";